
var products_on_page = $('.js-products-on-page');
var next_url = products_on_page.data('next-url');

var load_more_btn = $('.load-more-btn')
var load_more_spinner = $('.load-more__spinner')

if (next_url == "") {
  $(".load-more").addClass("is-hidden");
}

var load = true;
$(window).scroll(function () {
  var divTop = $('#scroll-to').offset().top,
    divHeight = $('#scroll-to').outerHeight(),
    wHeight = $(window).height(),
    windowScrTp = $(this).scrollTop();
  if ((windowScrTp > (divTop + divHeight - wHeight)) && (next_url != "")) {
    if (load) {
      load = false;
      $('body').find('.load-more-btn').trigger('click');
    }
  }
});


function loadMoreProducts() {
  // Preserve current URL parameters (including filters) when loading more
  var current_params = window.location.search;
  var ajax_url = next_url;

  // If we have filter parameters in the current URL, add them to the AJAX request
  if (current_params && current_params.includes('filter.v.price')) {
    // Extract filter parameters
    var urlParams = new URLSearchParams(current_params);
    var filterParams = [];
    urlParams.forEach(function(value, key) {
      if (key.startsWith('filter.v.price')) {
        filterParams.push(key + '=' + value);
      }
    });

    // Append filter parameters to the next_url
    if (filterParams.length > 0) {
      var separator = ajax_url.includes('?') ? '&' : '?';
      ajax_url = ajax_url + separator + filterParams.join('&');
    }
  }

  $.ajax(
    {
      url: ajax_url,
      type: 'GET',
      dataType: 'html',
      beforeSend: function () {
        load_more_btn.hide();
        load_more_spinner.show();
      }
    }
  ).done(function (next_page) {

    load_more_spinner.hide();
    load_more_btn.show();

    var new_products = $(next_page).find('.js-products-on-page');
    var new_url = new_products.data('next-url');

    next_url = new_url;

    if (next_url == "") {
      $(".load-more").addClass("is-hidden");
    }

    products_on_page.append(new_products.html());

    // Initialize product reviews if SPR is available
    if (typeof SPR !== 'undefined') {
      SPR.registerCallbacks();
      SPR.initRatingHandler();
      SPR.initDomEls();
      SPR.loadProducts();
      SPR.loadBadges();
    }

    // Apply price filter to newly loaded products immediately
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.applyPriceFilterToProducts) {
      FacetFiltersForm.applyPriceFilterToProducts();
    }

    // Re-sort products if sorting by price
    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.applySortByPrice) {
      FacetFiltersForm.applySortByPrice();
    }

    load = true;
  });
}